import {priority} from '@priority-software/priority-proto-api/lib';
import {Flex, Scrollbar, Text, Icon, PriorityIcon} from '@priority-software/priority-style-react';
import React from 'react';
import styles from './styles.module.scss';
import {isRTL} from '../../../../Localization';
import {createDataTestId} from '../../../../utils/dataTestId';
import {BasicFormData} from '../../types';

interface Props {
    selected: priority.netitems.nrest.ITreeNode[];
    onRemove: (field: priority.netitems.nrest.ITreeNode, currentForm: BasicFormData) => void;
    currentForm: BasicFormData;
}
const FieldSelectedList = ({selected, onRemove, currentForm}: Props) => {
    return (
        <Scrollbar autoHide style={{width: '100%'}} rtl={isRTL()}>
            <div className={styles.listContainer}>
                {selected?.map(field => (
                    <Flex
                        key={field.NodeId}
                        componentClasses={styles.selectedField}
                        {...createDataTestId('new-report-selected-field-item', true)}
                    >
                        <Text
                            wrap={false}
                            skin="paragraph-2"
                            textColor="primary-700"
                            {...createDataTestId('new-report-selected-field-title', true)}
                        >
                            {field.OrigTitle || field.Title}
                        </Text>
                        <Flex justifyContent="flex-end">
                            <Text
                                skin="label-1"
                                textColor="secondary-400"
                                {...createDataTestId('new-report-selected-field-form-title', true)}
                            >
                                {field.FormTitle}
                            </Text>
                            <Icon
                                iconColor="secondary-500"
                                icon={PriorityIcon.x}
                                onClick={() => onRemove(field, currentForm)}
                            />
                        </Flex>
                    </Flex>
                ))}
            </div>
        </Scrollbar>
    );
};

export default FieldSelectedList;
